import { classNames } from "@punks/ui-core"

export interface PagePaddingProps {
  children: any
  className?: string
}

const PagePadding = ({ children, className }: PagePaddingProps) => {
  return <div className={classNames("xl:px-11", className)}>{children}</div>
}

export default PagePadding
